export const CHAT_SETTINGS_ENDPOINT = '/p/v2/chat/settings';

export const CHAT_SETTINGS_BY_BRAND_ID_ENDPOINT =
  '/p/v2/chat/brands/:brandId/settings';

export const CHAT_SETTINGS_VERSION_ENDPOINT =
  '/p/v1/chat/settings/versions/latest';

export const CHAT_SETTINGS_VERSION_BY_BRAND_ID_ENDPOINT =
  '/p/v1/chat/brands/:brandId/settings/versions/latest';
